import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <div className="Footer">
            
            <div className="Footer-part1">

                <div className="Footer-part1-part1">

                    
                    <p className="Footer-part1-part1-lable">design & estabilished by</p>
                    <br/>
                    <pre className="Footer-part1-part1-name">         Mehdi Jafarzadeh</pre>
                    

                </div>

                <div className="Footer-part1-part2">

                    <a href="tel:+989373293420" className="Footer-part1-part2-container">

                        <img src="files/img/white-phone.png" className="Footer-part1-part2-img" alt="" />

                        <p className="Footer-part1-part2-txt">09373293420</p>

                    </a>

                    <a href="https://wa.me/989373293420" className="Footer-part1-part2-container">

                        <img src="files/SVG/white-whatsapp.svg" className="Footer-part1-part2-img" alt="" />

                        <p className="Footer-part1-part2-txt">09373293420</p>

                    </a>

                    <a href="https://instagram.com/webco.online?utm_medium=copy_link" className="Footer-part1-part2-container">

                        <img src="files/SVG/white-instagram.svg" className="Footer-part1-part2-img" alt="" />

                        <p className="Footer-part1-part2-txt">webco.online</p>

                    </a>

                    <a href="mailto:mehdijafarzedehh4@gmail.com" className="Footer-part1-part2-container">

                        <img src="files/img/white-email.png" className="Footer-part1-part2-img" alt="" />

                        <p className="Footer-part1-part2-txt">mehdijafarzedehh4@gmail.com</p>

                    </a>


                </div>
                
                <div className="Footer-part1-part3">

                    <div className="Footer-part1-part3-lable-container">
                    
                        <pre className="Footer-part1-part3-lable">                       صفحات پربازدید      </pre>
                    
                    </div>

                    <br/>

                    <div className="Footer-part1-part3-menu-container">

                        <div className="Footer-part1-part3-menu">

                            <a href="" className="Footer-part1-part3-menu-item"> <pre>      درباره ما</pre> </a>
                            <a href="" className="Footer-part1-part3-menu-item"> <pre>      خدمات </pre></a>
                            <a href="" className="Footer-part1-part3-menu-item"> <pre>      پکیج های آموزشی</pre></a>

                        </div>

                    </div>

                </div>

            </div>
            
            <div className="Footer-part2">

            </div>
            
            <div className="Footer-part3">

                <p className="Footer-copyright">Copyright © 2021 Webco. All rights reserved.</p>

            </div>

        </div>
    )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/default/Footer/Footer.js